import { atom } from 'jotai';

import { ReactNode } from 'react';

/**
 * This atom is used to store a flash message
 *
 * Flash messages are temporary messages that are displayed to the user at the
 * top of the next page. After refreshing or navigating away, they disappear.
 */

export type FlashMessageType = 'error' | 'info' | 'warning' | 'success';

export type FlashMessageAtom = {
  type: FlashMessageType;
  heading: string;
  message: ReactNode;
  redirectCount?: number; // number of redirects/path changes before clearing the message (If not defined, will be set to "1", meaning the message will persist onto the next page)
};

export const flashMessageAtom = atom<FlashMessageAtom | null>(null);
